'use strict';

var _ = require('lodash');
var BenchmarkService = function BenchmarkService($log, $window, configurationService) {
  var timings = {};
  function start(metricName) {
    var isCollectionEnabled = configurationService.getTimingsEnabled();
    if (isCollectionEnabled && metricName) {
      var startTime = $window.performance.now();
      var timingId = _.uniqueId(metricName + '-');
      timings[timingId] = {
        metricName: metricName,
        startTime: startTime
      };
      return timingId;
    }
  }
  function end(timingId) {
    var isCollectionEnabled = configurationService.getTimingsEnabled();
    if (isCollectionEnabled && timingId) {
      var endTime = $window.performance.now();
      var timing = timings[timingId];
      if (!timing) {
        $log.warn('Could not log timing for', timingId);
        return;
      }
      var metricName = timing.metricName;
      var startTime = timing.startTime;
      var elapsedTime = endTime - startTime;
      $log.timing(metricName, elapsedTime);
      delete timings[timingId];
    }
  }
  var benchmark = function benchmark(metricName, measuredFunction) {
    var isCollectionEnabled = configurationService.getTimingsEnabled();
    if (isCollectionEnabled) {
      var timingId = this.start(metricName);
      var result = measuredFunction();
      this.end(timingId);
      return result;
    }
    return measuredFunction();
  };
  var benchmarkPromise = function benchmarkPromise(metricName, measuredFunction) {
    var isCollectionEnabled = configurationService.getTimingsEnabled();
    if (isCollectionEnabled) {
      var timingId = this.start(metricName);
      var promise = measuredFunction();
      promise["finally"](function (timingId, thisArg) {
        return function () {
          thisArg.end(timingId);
        };
      }(timingId, this));
      return promise;
    }
    return measuredFunction();
  };
  return {
    benchmark: benchmark,
    benchmarkPromise: benchmarkPromise,
    start: start,
    end: end
  };
};
module.exports = BenchmarkService;
BenchmarkService.$inject = ['$log', '$window', 'ConfigurationService'];